import moment from 'moment';
export class AppAffiliateModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get formattedLaunchedAt() {
        const launchDate = new Date(this.launchedAt);
        return moment(launchDate).format('LLL');
    }
    get formattedLaunchedAtDate() {
        const launchDate = new Date(this.launchedAt);
        return moment(launchDate).format('LL');
    }
    get deleteable() {
        return (this.merchantType === 'merchant' &&
            !this.activePagePhotoUrl &&
            this.request.status === 'pending');
    }
}
